import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);

// Only register SW for the public (Cloudflare Pages) build
if (process.env.REACT_APP_PUBLIC_MODE === 'true') {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}
